import api from "./api";

// The real pick screen — only SKUs that have an actual order against them.
export async function getOrderPickQueue(params = {}) {
  const res = await api.get("/api/picking/order-queue", { params });
  return res.data?.queue || [];
}

export async function getPickingQueue(params = {}) {
  const res = await api.get("/api/picking/queue", { params });
  return res.data?.queue || [];
}
export async function createPickingWave(payload) {
  const res = await api.post("/api/picking/waves", payload);
  return res.data?.wave;
}
export async function confirmPick(sku) {
  const res = await api.post("/api/picking/confirm", { sku });
  return res.data;
}
